module.exports = __webpack_public_path__ + "img/IMG-20200519-WA0021.034be734.jpg";